<template>
  <div style="margin-top: 113px" v-if="myProfile">
    <v-container>
      <v-card>
        <v-snackbar
          v-model="snackbar"
          :color="snackBarColor"
          :timeout="snackBarTimeout"
        >
          <b>{{ snackBarText }} </b>
        </v-snackbar>
        <v-card-title>
          My profile
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="myProfile.registrationNumber"
              label="Europcar Idr"
              required
              readonly
            ></v-text-field>
            <v-text-field
              v-model="myProfile.firstName"
              label="First Name"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="myProfile.lastName"
              label="Last Name"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="myProfile.login"
              label="Login"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="myProfile.workingCountry.label"
              label="Perimeter"
              readonly
            ></v-text-field>
            <v-select
              v-model="myProfile.langue"
              :items="refLangue"
              label="Display Language"
              item-text="label"
              item-value="code"
            ></v-select>
            <v-text-field
              v-model="myProfile.jobTitle"
              label="Job title"
              readonly
            ></v-text-field>
            <v-select
              v-model="myProfile.businessUnit.code"
              :items="refBusinessUnits"
              label="Business Unit"
              item-text="label"
              item-value="code"
              readonly
            ></v-select>
            <v-text-field
              v-model="myProfile.companyEntryDate"
              label="Entry Date"
              v-on="on"
              readonly
            ></v-text-field>
            <v-select
              v-model="myProfile.groupFunction.code"
              :items="refGroupFunctions"
              label="Group function"
              item-text="label"
              item-value="code"
              readonly
            ></v-select>
            <v-select
              v-model="myProfile.locationCountry.code"
              :items="refLocationCountry"
              label="Location Country"
              item-text="label"
              item-value="code"
              disabled
            ></v-select>
            <v-text-field
              v-model="myProfile.locationCity"
              label="Location City"
              disabled
            ></v-text-field>
            <v-select
              v-model="myProfile.employers.code"
              :items="refEmployer"
              label="Employer"
              item-text="label"
              item-value="code"
              disabled
            ></v-select>
            Strong line manager : {{ myProfile.slm.firstName }}
            {{ myProfile.slm.lastName }}
            <div
              v-if="
                myProfile.slm.jobTitle != '' &&
                  myProfile.slm.jobTitle != undefined
              "
            >
              ({{ myProfile.slm.jobTitle }})
            </div>
            <v-divider></v-divider>
            Dotted line manager : {{ myProfile.dlm.firstName }}
            {{ myProfile.dlm.lastName }}
            <div
              v-if="
                myProfile.dlm.jobTitle != '' &&
                  myProfile.dlm.jobTitle != undefined
              "
            >
              ({{ myProfile.dlm.jobTitle }})
            </div>
            <v-textarea
              disabled
              maxlength="800"
              class="mt-3 mb-3"
              label="Notes"
              hide-details
              v-model="myProfile.managersComments"
              outlined
              row-height="5"
            ></v-textarea>
            <v-divider></v-divider>
            Delegate : {{ myProfile.delegate.firstName }}
            {{ myProfile.delegate.lastName }}
            <div
              v-if="
                myProfile.delegate.jobTitle != '' &&
                  myProfile.delegate.jobTitle != undefined
              "
            >
              ({{ myProfile.delegate.jobTitle }})
            </div>
            <v-divider></v-divider>
            <v-checkbox
              v-model="myProfile.active"
              label="Active"
              readonly
            ></v-checkbox>
            <v-checkbox
              v-model="myProfile.workInFrance"
              label="Concerned by Entretien Pro and Bilan"
              readonly
            ></v-checkbox>
            <v-btn color="success" class="mr-4" @click="validate">
              Validate
            </v-btn>
            <v-btn color="warning" @click="resetForm">
              Reset Form
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Profile",
  data() {
    return {
      // [START] Data for autocomplete search
      descriptionLimit: 60,
      entriesForSLM: [],
      entriesForDLM: [],
      myProfile: null,
      isLoadingForSLM: false,
      isLoadingForDLM: false,
      slmanager: null,
      dlmanager: null,
      searchForSLM: null,
      searchForDLM: null,
      refLangue: [],
      countForSLM: 0,
      countForDLM: 0,
      // [END] Data for autocomplete search
      findByName: "",
      refBusinessUnits: [],
      refGroupFunctions: [],
      refLocationCountry: [],
      refEmployer: [],
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,
    };
  },
  computed: {
    itemsForSLM() {
      return this.entriesForSLM.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
    itemsForDLM() {
      return this.entriesForDLM.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
  },
  watch: {
    searchForSLM(val) {
      // Items have already been loaded

      // Items have already been requested
      if (this.isLoadingForSLM) return;

      this.isLoadingForSLM = true;

      // Lazily load input items
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.countForSLM = res.data.length;
          this.entriesForSLM = res.data;
        })
        .finally(() => (this.isLoadingForSLM = false));
    },
    searchForDLM(val) {
      // Items have already been loaded

      // Items have already been requested
      if (this.isLoadingForDLM) return;

      this.isLoadingForDLM = true;

      // Lazily load input items
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.countForDLM = res.data.length;
          this.entriesForDLM = res.data;
        })
        .finally(() => (this.isLoadingForDLM = false));
    },
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init: function() {
      this.loadData();
      this.loadRefs();
    },
    loadRefs: function() {
      this.fillBusinessUnits();
      this.fillGroupFunctions();
      this.fillLanguages();
      this.fillLocationCountrys();
      this.fillEmployers();
    },
    fillLanguages: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api-public/ref/languages", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refLangue = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillBusinessUnits: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/businessUnits", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refBusinessUnits = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillGroupFunctions: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/groupFunctions", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refGroupFunctions = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillLocationCountrys: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/locationCountrys", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refLocationCountry = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillEmployers: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/employers", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refEmployer = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    validate: function() {
      if (this.entriesForSLM[0]) {
        this.myProfile.slm = this.entriesForSLM[0];
      }
      if (this.entriesForDLM[0]) {
        this.myProfile.dlm = this.entriesForDLM[0];
      }
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var myMethod = "put";

      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/users/", {
        method: myMethod,
        credentials: "include",
        headers: myHeaders,
        body: JSON.stringify(this.myProfile),
      }).then((response) => {
        this.snackbar = true;
        if (response.status >= 200 && response.status < 300) {
          this.snackBarText = "Saved successfully";
          this.snackBarColor = "success";
          this.init();
        } else {
          this.snackBarText = "Something went wrong";
          this.snackBarColor = "error";
          this.init();
        }
      });
    },
    resetForm: function() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
    },
    loadData: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/users/my", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.myProfile = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
  },
};
</script>
